import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { createGlobalStyle } from 'styled-components';

// Import components
import EmailVerification from './components/pages/auth/EmailVerification';
import OtpVerification from './components/pages/auth/OtpVerification';
import ApplicationForm from './components/pages/form/ApplicationForm';
import AdminLogin from './components/pages/admin/AdminLogin';
import AdminDashboard from './components/pages/admin/AdminDashboard';
import ProtectedRoute from './components/common/ProtectedRoute';
import App from './App'; // Import App from App.tsx
import { SessionProvider } from './context/SessionContext';

// Global styles
const GlobalStyle = createGlobalStyle`
  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
  }
  
  body {
    font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2d3748;
    line-height: 1.5;
    background-color: #f8f9fa;
  }
  
  h1, h2, h3, h4, h5, h6 {
    font-weight: 600;
    line-height: 1.3;
  }
  
  p {
    margin-bottom: 1rem;
  }
  
  button, input, select, textarea {
    font-family: inherit;
  }
  
  a {
    color: #4c6ef5;
    text-decoration: none;
  }
  
  a:hover {
    text-decoration: underline;
  }
`;

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <BrowserRouter>
    <SessionProvider>
      <GlobalStyle />
      <App />
    </SessionProvider>
  </BrowserRouter>
);
